<template>
  <!-- 服务费弹窗 -->
  <van-popup v-model="showServicePop" class="service-popup">
    <div class="title">服务费</div>
    <div class="content">
      <div class="content-scroll">
        <table class="table">
          <tr class="table-title">
            <th>年限</th>
            <th>服务比例</th>
            <th v-if="level==1">活动补贴比例</th>
            <th>服务费</th>
          </tr>
          <tr class="table-row" v-for="(item,i) in commissonsList" :key="i">
            <td v-if="item.payNum==1">首年</td>
            <td v-else>第{{item.payNum}}年</td>
            <td>{{item.commission*1}}%</td>
            <td v-if="level==1">{{item.subsidyCommission*1?item.subsidyCommission*1+'%':'--'}}</td>
            <td>{{item.incomes*1}}元</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="close" @click="hideModal">
      <i class="iconfont icon-guanbi"></i>
    </div>
  </van-popup>
</template>

<script>
import { loading } from "@/api/mixins";
export default {
  props: ["show", "id"],
  mixins: [loading],
  data() {
    return {
      level:"",
      commissonsList: [],
      showServicePop: false
    };
  },
  mounted() {
    this.level = this.$route.query.level
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.openServicePop();
      }
    }
  },
  methods: {
    hideModal() {
      this.showServicePop = false;
      this.$emit('update:show', false);
    },
    openServicePop() {
      this.loading = true;
      this.showServicePop = true;
      this.$http({
        url: "/app/policy/getPolicyCommisson",
        type: "PUT",
        data: {
          policyId: this.id,
          orderBy: "pay_num ASC,id",
          pageSize: 9999,
          pageNum: 1
        }
      }).then(res => {
        this.loading = false;
        var fee = res.data.data.policy.fee;
        this.commissonsList = res.data.data.commissons.records;
        for (var i = 0; i < this.commissonsList.length; i++) {
          var item = this.commissonsList[i];
          if (item.subsidyCommission) {
            this.commissonsList[i].fwfee = (
              (fee * (item.subsidyCommission * 1 + item.commission * 1)) /
              100
            ).toFixed(2);
          } else {
            this.commissonsList[i].fwfee = (
              (fee * (item.commission * 1)) /
              100
            ).toFixed(2);
          }
        }
        console.log(this.commissonsList);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.service-popup{
  width: 94%;
  min-height: r(600);
  max-height: r(1000);
  background-color: transparent;
  overflow-y: hidden;
  .title{
    width: 100%;
    height: r(80);
    line-height: r(80);
    color: #fff;
    background-color: #209df9;
    text-align: center;
    font-size: r(30);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
  .content{
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    width: 100%;
    min-height: r(400);
    max-height: r(800);
    background-color: #fff;
    padding: r(20);
    overflow-y: hidden;
    .content-scroll {
      width: 100%;
      min-height: r(360);
      max-height: r(760);
      overflow-y: auto;
      .table{
        width: calc(100% - 2px);
        margin-bottom: r(20);
        .table-title{
          width: 100%;
          height: r(50);
          line-height: r(50);
          background-color: #e1e1e1;
          font-size: r(26);
          th{
            width: 23%;
            text-align: center;
            font-weight: normal;
            border-left: r(1) solid #ccc;
          }
          th:nth-child(3){
            width: 31%;
            text-align: center;
          }
          th:nth-child(4){
            border-right: r(1) solid #ccc;
          }
        }
        .table-row{
          width: 100%;
          min-height: r(50);
          font-size: r(26);
          border-bottom: r(1) solid #ccc;
          td{
            width: 23%;
            text-align: center;
            border-left: r(1) solid #ccc;
            height: r(50);
          }
          td:nth-child(3){
            width: 31%;
            text-align: center;
          }
          td:nth-child(4){
            border-right: r(1) solid #ccc;
          }
        }
      }
    }
  }
  .close{
    margin-top: r(10);
    text-align: center;
    .iconfont{
      font-size: r(70);
      color: #ccc;
    }
  }
}
</style>